import { useSearchParams } from "react-router-dom";
import { ErrorPage } from "@/components/ui/ErrorPage";

export default function SessioneScaduta() {
  const [params] = useSearchParams();
  const motivo = params.get("motivo");

  const messaggio =
    motivo === "session_expired" ? (
      <>
        La tua sessione è scaduta per inattività.<br />
        <strong className="text-primary">
          Tranquillo: le risposte che hai dato sono state salvate.
        </strong>
        <br />
        Accedi di nuovo per riprendere da dove avevi lasciato.
      </>
    ) : (
      <>
        Sessione scaduta. Le tue risposte sono state salvate.<br />
        Accedi di nuovo per continuare.
      </>
    );

  return (
    <ErrorPage
      emoji="🔐"
      titolo="Sessione scaduta"
      messaggio={messaggio}
      cta={{ label: "Accedi", to: "/accedi" }}
    />
  );
}
